export default "__VITE_ASSET__DrG4A1el__"